import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShopsRoutingModule } from './shops-routing.module';
import { ShopsComponent } from './shops.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';
import { ShopDetailComponent } from './shop-detail/shop-detail.component';
import { ShopImportComponent } from './shop-import/shop-import.component';

@NgModule({
  declarations: [
    ShopsComponent,
    ShopDetailComponent,
    ShopImportComponent
  ],
  imports: [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  ShopsRoutingModule,
  NgZorroAntdModule,
  SharedModule,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class ShopsModule { }
